export default {
  HIDDEN: 'HIDDEN',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  UNAVAILABLE_FOR_DELIVERY: 'UNAVAILABLE_FOR_DELIVERY',
}